import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=2067fc92&"
import script from "./AssessmentCard.vue?vue&type=script&lang=js&"
export * from "./AssessmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports